export function join(...args) {
  return args.join('')
}
